import styled from "styled-components";
import {
  NavLink,
} from "react-router-dom";
import breakpoints from "../../../../theme-style/breakpoints";

import GenericTitleWithToolTip from "../../../../components/molecules/GenericTitleWithToolTip";

export const StyledTitleWithToolTip = styled(GenericTitleWithToolTip)`
  color: white;
  font-size: 16px;
  font-weight: 700;
  padding: 0 0 8px 0;
  @media ${breakpoints.mobileXL} {
    padding: 0 0 15px 0;
  }
`;

export const DesktopMessageIconWrapper = styled.span`
  max-width: 15px;
  max-height: 15px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 0 2px 0;
`;

export const ArrowIconWrapper = styled.span`
  max-width: 7px;
  max-height: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 0 0 auto;
  svg path{
    transition: all .2s ease-out;
  }
`;

export const SkillsDomainsItemText = styled.span`
  margin: 4px 0 0 0;
  font-size: 12px;
  color: #BBBBBB;
  line-height: 14px;
  font-weight: 600;
`;

export const SkillsDomainsItemTitle = styled.strong`
  font-weight: 600;
  font-size: 14px;
  color: #5A5A5A;
  transition: all .2s ease-out;
`;

export const SkillsDomainsItemContent = styled.div`
  display: flex;
  justify-content: center;
  align-items: flex-start;
  flex-direction: column;
`;

export const SkillsDomainsItemCircle = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 50px;
  min-width: 50px;
  height: 50px;
  min-height: 50px;
  border-radius: 100px;
  background-color: #397dd2;
  font-size: 24px;
  color: #FFFFFF;
  font-weight: 700;
  margin-right: 15px;
`;

export const SkillsDomainsItem = styled(NavLink)`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin: 0;
  background-color: #FFFFFF;
  height: auto;
  cursor: pointer;
  border-bottom: 1px solid #F4F4F4;
  transition: all .2s ease-out;
  text-decoration: none;
  list-style: none;
  padding: 10px 15px 10px 10px;
  @media ${breakpoints.mobileXL} {
    padding: 15px 20px 15px 15px;
  }
  &:last-child{
    border-bottom: 0;
    border-radius: 0 0 6px 6px;
  }
  &:hover{
    background-color: #FAFAFA;
    ${ArrowIconWrapper}{
      svg{
        path{
          fill: #397dd2;
          stroke: #397dd2;
        }
      }
    }
  }
`;

export const SkillsDomainsList = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  width: 100%;
  padding: 0;
  margin: 0;
`;

export const SkillsDomainsHeadTitle = styled.strong`
  font-size: 16px;
  color: #4A90E2;
  font-weight: 600;
  text-align: left;
`;

export const SkillsDomainsHeadCircle = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #4A90E2;
  border-radius: 100px;
  width: 30px;
  min-width: 30px;
  height: 30px;
  min-height: 30px;
  margin-right: 25px;
`;

export const SkillsDomainsHead = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 15px 25px;
  margin: 0;
  background-color: #FFFFFF;
`;

export const SkillsDomainsDiv = styled.div`
  border-radius: 6px;
  overflow: hidden;
  padding: 0 0 25px 0;
`;

export const SkillsDomainsWrapper = styled.div`

`;

export const Container = styled.div`
  width: 100%;
  height: auto;
  min-height: calc(100vh - 110px);
  background-color: #357ED3;
  padding: 15px;
  box-sizing: border-box;
  @media ${breakpoints.mobileXL} {
    padding: 25px;
  }
`;
